import { types, flow } from 'mobx-state-tree';
import { ApiStore } from './ApiStore';
import { Module } from './Module';

const _modulesStore = types.model('ModulesStore', {
    modules: types.array(Module)
}).actions((self) => ({
    load: flow(function* (companyId) {
        try {
            const response = yield self.getApi(`/modules/${companyId}?populate=*`);
            // Ensure we have a valid array, default to empty array if not
            const modulesData = Array.isArray(response) ? response : [];
            self.modules.clear();
            self.modules.push(...modulesData);
        } catch (error) {
            console.warn('Failed to load modules:', error);
            // Default to empty array on error
            self.modules.clear();
        }
    }),
})).views(self => ({
    get allArticles() {
        return self.modules.reduce((prev, current) => {
            prev.push(...current.articles);
            return prev;
        }, [])
    }
}));

export const ModulesStore = types.compose(_modulesStore, ApiStore);